import React from "react";
import "../styles/ComoTrabajamos.css";

const ComoTrabajamos = ({ traducciones }) => {
  return (
    <div className="como-container py-5">
      <div className="container">
        <div className="row">
          {/* Columna izquierda */}
          <div className="col-md-6 mb-4 mb-md-0">
            <h2 className="como-titulo">
              {traducciones.como
                ? traducciones.como.titulo1
                : "¿CÓMO TRABAJAMOS?"}
            </h2>
            <div
              className="como-descripcion"
              dangerouslySetInnerHTML={{
                __html: traducciones.como ? traducciones.como.texto1 : "",
              }}
            ></div>
          </div>

          {/* Columna derecha */}
          <div className="col-md-6">
            <h2 className="porque-titulo">
              {traducciones.como
                ? traducciones.como.titulo2
                : "¿POR QUÉ OPMS CONSULTING?"}
            </h2>
            <div
              className="porque-descripcion"
              dangerouslySetInnerHTML={{
                __html: traducciones.como ? traducciones.como.texto2 : "",
              }}
            ></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ComoTrabajamos;